import Dispatcher from "../Dispatcher";
import {PaymentMethod} from "../models/PaymentMethod";
import {PaymentMethodAction} from "../actions/PaymentMethodActions";
import {Store} from "flux/utils";
import $ = require("jquery");

let paymentMethods: Array<PaymentMethod> = [];
let baseApiUrl = window.emanagerBaseApiAddress;
let websiteId = window.websiteId;
let storeId = window.storeId;
let customerId = window.customerId;

class PaymentMethodStore extends Store<PaymentMethodAction<PaymentMethod|Array<PaymentMethod>>>
{
	getPaymentMethods()
	{
		return paymentMethods;
	}

	loadPaymentMethods()
	{
		return $.ajax({
				url: `${baseApiUrl}website/${websiteId}/store/${storeId}/paymentmethod%3FcustomerId=${window.customerId}`,
				contentType: "application/json",
				method: "GET"
			})
			.done((methods: Array<PaymentMethod>) =>
			{
				this.getDispatcher().dispatch(new PaymentMethodAction("LOADED_PAYMENT_METHODS", methods));
			});
	}

// ReSharper disable once InconsistentNaming
	__onDispatch(action: PaymentMethodAction<PaymentMethod|Array<PaymentMethod>>)
	{
		switch (action.type)
		{
			case "LOADED_PAYMENT_METHODS":
			{
				paymentMethods = action.value as Array<PaymentMethod>;
				this.__emitChange();
			}
			default:
		}
	}
}

export default new PaymentMethodStore(Dispatcher);


// WEBPACK FOOTER //
// ./src/stores/PaymentMethodStore.ts